import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import KenColors from "../../Helpers/Themes/kenColors";

interface AppTabsProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  tabs: string[];
  indicatorColor?: string;
  variant?: "standard" | "scrollable" | "fullWidth"; // 👈 new prop added
}

export const AppTabs: React.FC<AppTabsProps> = ({
  value,
  onChange,
  tabs,
  indicatorColor = KenColors?.ClientPrimaryII,
  variant = "standard", // 👈 default if not provided
}) => {
  return (
    <Box>
      <Tabs
        value={value}
        onChange={onChange}
        variant={variant} // 👈 use prop instead of hardcoding
        TabIndicatorProps={{
          style: { backgroundColor: indicatorColor || KenColors?.ClientPrimaryII },
        }}
        aria-label="app-tabs"
      >
        {tabs.map((label, index) => (
          <Tab
            key={label}
            label={label}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              fontSize: 16,
              "@media (max-width: 600px)": {
                fontSize: 14,
              },
             
              "&.Mui-selected": {
                color: "#373A45",
              },
            }}
            id={`app-tab-${index}`}
            aria-controls={`app-tabpanel-${index}`}
          />
        ))}
      </Tabs>
    </Box>
  );
};
